import { Icon } from '@chakra-ui/icons';

export const IconReference = () => (
	<Icon
		width="11px"
		height="11px"
		viewBox="0 0 11 11"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M0.832031 10.1668L9.16536 1.8335"
			stroke="white"
			strokeWidth="2"
			strokeLinejoin="round"
		/>
		<path
			d="M0.832031 1.8335H9.16536V10.1668"
			stroke="white"
			strokeWidth="2"
			strokeLinejoin="round"
		/>
	</Icon>
);
